"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatesInRange = exports.convertTimestampToDateString = void 0;
exports.formatChatListDate = formatChatListDate;
exports.formatChatMessageTime = formatChatMessageTime;
exports.convertDateFormat = convertDateFormat;
exports.formatTime = formatTime;
exports.formatSchedulerDate = formatSchedulerDate;
exports.formatRescheduleDateTime = formatRescheduleDateTime;
exports.formatLabRequisitionDate = formatLabRequisitionDate;
exports.formatVisitDate = formatVisitDate;
exports.normalizePhoneNumberInput = normalizePhoneNumberInput;
exports.formatPhoneNumberInput = formatPhoneNumberInput;
exports.formatDisplayPhoneNumber = formatDisplayPhoneNumber;
exports.dateAgoTime = dateAgoTime;
exports.dateAgo = dateAgo;
exports.sortByDate = sortByDate;
exports.getFirstAndLastDateOfMonth = getFirstAndLastDateOfMonth;
exports.formatDateToYYYYMMDD = formatDateToYYYYMMDD;
const dayjs_1 = __importDefault(require("dayjs"));
function formatChatListDate(value) {
    const date = new Date(value);
    date.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    const diffTime = Math.abs(date.getTime() - today.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (+date == +today) {
        return (0, dayjs_1.default)(value).format("h:mm A");
    }
    else if (+date == +yesterday) {
        return `Yesterday`;
    }
    else if (diffDays > 1 && diffDays < 6) {
        return (0, dayjs_1.default)(value).format("dddd");
    }
    else {
        return (0, dayjs_1.default)(value).format("MM/DD/YY");
    }
}
function formatChatMessageTime(value) {
    const date = new Date(value);
    date.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    const diffTime = Math.abs(date.getTime() - today.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (+date == +today) {
        return `Today - ${(0, dayjs_1.default)(value).format("h:mm A")}`;
    }
    else if (+date == +yesterday) {
        return `Yesterday - ${(0, dayjs_1.default)(value).format("h:mm A")}`;
    }
    else if (diffDays > 1 && diffDays < 6) {
        return (0, dayjs_1.default)(value).format("dddd - h:mm A");
    }
    else {
        return (0, dayjs_1.default)(value).format("MM/DD/YY - h:mm A");
    }
}
function convertDateFormat(dateString, targetFormat) {
    const parsedDate = (0, dayjs_1.default)(dateString, ["MM/DD/YYYY", "YYYY-MM-DD"]);
    if (!parsedDate.isValid()) {
        throw new Error(`Unable to parse date string "${dateString}"`);
    }
    return parsedDate.format(targetFormat);
}
function formatTime(value) {
    return (0, dayjs_1.default)(value).format("h:mm A");
}
function formatSchedulerDate(value) {
    return (0, dayjs_1.default)(value).format("MMM D, YYYY");
}
function formatRescheduleDateTime(value) {
    return (0, dayjs_1.default)(value).format("h:mm A, MMM D, YYYY");
}
function formatLabRequisitionDate(value, existingFormat) {
    return (0, dayjs_1.default)(value, existingFormat).format("MMM D, YYYY");
}
function formatVisitDate(value) {
    return (0, dayjs_1.default)(value).format("MM/DD/YY");
}
function normalizePhoneNumberInput(value, previousValue) {
    if (!value)
        return value;
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;
    if (!previousValue || value.length > previousValue.length) {
        if (cvLength < 4)
            return currentValue;
        if (cvLength < 7)
            return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
        return `${currentValue.slice(0, 3)}-${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
    }
}
// Formats phone number input for both US and international numbers
// US: (248) 794-3763, International: +91 5463827364
function formatPhoneNumberInput(value, countryCode) {
    if (typeof value !== "string" || !value)
        return "";
    const digits = value.replace(/\D/g, "");
    // US formatting only
    if (countryCode === "+1") {
        if (digits.length <= 3)
            return digits;
        if (digits.length <= 6)
            return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    }
    // For all other countries, show plain digits
    return digits;
}
function formatDisplayPhoneNumber(countryCode, phoneNo) {
    const digits = phoneNo.replace(/\D/g, "");
    // US country code normalization : format as (XXX) XXX-XXXX without country code
    if (countryCode === "+1" && digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    // For other countries, show country code and number with a space
    return `${countryCode} ${digits}`;
}
function dateAgoTime(value) {
    try {
        if (value) {
            const seconds = Math.floor((Date.now() - value) / 1000);
            if (seconds < 29) {
                return "few sec ago";
            }
            const intervals = {
                year: 31536000,
                month: 2592000,
                week: 604800,
                day: 86400,
                hour: 3600,
                minute: 60,
                second: 1,
            };
            let counter;
            for (const i in intervals) {
                counter = Math.floor(seconds / intervals[i]);
                if (counter > 0) {
                    if (counter === 1) {
                        return `${counter} ${i} ago`;
                    }
                    else {
                        return `${counter} ${i}s ago`;
                    }
                }
            }
        }
        else {
            return value;
        }
    }
    catch (error) {
        return "";
    }
    return null;
}
function dateAgo(value, online) {
    try {
        if (value && !online) {
            const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
            if (seconds < 29) {
                return "Last seen few sec ago";
            }
            const intervals = {
                year: 31536000,
                month: 2592000,
                week: 604800,
                day: 86400,
                hour: 3600,
                minute: 60,
                second: 1,
            };
            let counter;
            for (const i in intervals) {
                counter = Math.floor(seconds / intervals[i]);
                if (counter > 0) {
                    if (counter === 1) {
                        return `Last seen ${counter} ${i} ago`;
                    }
                    else {
                        return `Last seen ${counter} ${i}s ago`;
                    }
                }
            }
        }
        else {
            if (value && online) {
                return "Online";
            }
            else {
                return "Offline";
            }
        }
    }
    catch (error) {
        return "Offline";
    }
}
function sortByDate(toBeSorted) {
    return (toBeSorted &&
        toBeSorted.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)));
}
// Convert your timestamp data to date strings
const convertTimestampToDateString = (timestamp) => {
    // Ensure the date is in local time, not UTC
    const date = new Date(timestamp);
    // Get local date parts
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
exports.convertTimestampToDateString = convertTimestampToDateString;
// Helper to get all dates in a range as YYYY-MM-DD
const getDatesInRange = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const dates = [];
    const current = new Date(startDate);
    while (current <= endDate) {
        dates.push(current.toISOString().split("T")[0]);
        current.setDate(current.getDate() + 1);
    }
    return dates;
};
exports.getDatesInRange = getDatesInRange;
function getFirstAndLastDateOfMonth(month, year) {
    const startDate = (0, dayjs_1.default)().year(year).month(month).date(1).toDate();
    const endDate = (0, dayjs_1.default)().year(year).month(month).endOf("month").toDate();
    return { startDate, endDate };
}
function formatDateToYYYYMMDD(date) {
    return (0, dayjs_1.default)(date).format("YYYY-MM-DD");
}
